import { CircularProgress } from "@mui/material";
import * as Sentry from "@sentry/react";
import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Pagination from "../../components/common/Pagination";
import NoCard from "../../components/userProfile/paymentMethod/noCard";
import BalanceCard from "../../components/wallet/BalanceCard";
import {
  checkUserBank,
  getBalance,
  getTransaction,
} from "../../setup/api/services/payment";
import { PROFILE_PATH_PARAMS, ROUTES } from "../../setup/constants";
import { AuthConfig } from "../../setup/context/config/authConfig";
import { EmptyContractsList } from "../contract/list/emptyContractList";
import TransactionsList from "./TransactionsList";
// styles
import styles from "./wallet.module.scss";

const Wallets = () => {
  const [bankInfoEmpty, setBankInfoEmpty] = useState<boolean>(false);
  const [page, setPage] = React.useState(1);
  const [pagesCount, setPagesCount] = React.useState(1);
  const [balanceInfo, setBalanceInfo] = React.useState(0);

  const pageSize = 10;
  const [loading, setLoading] = useState<boolean>(false);
  const [transactionsInfo, setTransactionsInfo] = React.useState([]);

  const userId = AuthConfig?.getUserInfo()?.id;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchBankInfo = useCallback(async () => {
    try {
      setLoading(true);
      const respons = await checkUserBank(userId);
      return respons;
    } catch (error) {
      Sentry.captureException(error);
      console.error;
    }
    setLoading(false);
  }, []);

  const fetchTransactionsInfo = useCallback(async (page) => {
    setLoading(true);
    try {
      const response = await getTransaction(page - 1, pageSize);
      setTransactionsInfo(response.data.content);
      setPagesCount(response.data.totalPages);
    } catch (error) {
      Sentry.captureException(error);
      console.error;
    }
    setLoading(false);
  }, []);

  const fetchBalanceInfo = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getBalance();
      setBalanceInfo(response.data.balance);
    } catch (error) {
      Sentry.captureException(error);
      console.error;
    }
    setLoading(false);
  }, []);
  const fetchWalletData = () => {
    fetchBankInfo()
      .then((res) => {
        if (res != undefined) {
          setBankInfoEmpty(false);
          fetchTransactionsInfo(page).then().catch(console.error);
          fetchBalanceInfo().catch(console.error);
        } else {
          setBankInfoEmpty(true);
        }
      })
      .catch(console.error);
  };
  useEffect(() => {
    fetchWalletData();
  }, []);

  const handlePaginationChange = (value: number) => {
    setPage(value);
    fetchTransactionsInfo(value).then().catch();
  };

  if (loading)
    return (
      <div className={classNames(styles["container"], styles["center"])}>
        <CircularProgress />
      </div>
    );

  return (
    <div className={classNames("page_layout", styles["container"])}>
      <h1>{t("lbl_wallets_wallets_heading")}</h1>

      {bankInfoEmpty ? (
        <div className="wallets-container-empty">
          <NoCard
            handleClick={() => {
              navigate(
                `${ROUTES.PROFILE}?path=${PROFILE_PATH_PARAMS.PAYMENT_METHOD}`
              );
            }}
          />
        </div>
      ) : (
        <>
          {transactionsInfo.length !== 0 ? (
            <>
              <BalanceCard balanceInfo={balanceInfo} />
              <div className={styles["tabbar"]}>
                <div className={styles["tab"]}>
                  <h3 className={classNames("primary")}>
                    {t("lbl_wallets_all_trans")}
                  </h3>
                  <span className={styles["tab__counter"]}>
                    <p className={classNames("primary", "subtitle2")}>
                      {transactionsInfo.length}
                    </p>
                  </span>
                </div>
              </div>
              {transactionsInfo.map((transactionsInfoItem: any) => {
                return (
                  <TransactionsList
                    key={transactionsInfoItem.id}
                    transactionsInfo={transactionsInfoItem}
                  />
                );
              })}
            </>
          ) : (
            <EmptyContractsList feedBack={fetchWalletData} />
          )}
          {transactionsInfo.length !== 0 && (
            <div
              className={
                transactionsInfo.length
                  ? styles["paginatorContainer"]
                  : styles["hide"]
              }>
              <Pagination
                pagesCount={pagesCount}
                page={page}
                length={pageSize}
                handlePaginationChange={handlePaginationChange}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default Wallets;
